// import React, { useState, useEffect, useCallback } from "react";
// import { toast } from "react-toastify";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import SummaryApi from "../../common/SummaryApi";
// import api from "../../common/apiClient";

// const FREQUENCIES = [
//   { label: "Monthly", value: "1_MONTH" },
//   { label: "Quarterly", value: "3_MONTHS" },
//   { label: "Half-Yearly", value: "6_MONTHS" },
//   { label: "Annual", value: "12_MONTHS" }
// ];

// export default function IndividualKraForm({ kra, kraId, onClose, onSave, onBackToWizard }) {
//   const [saving, setSaving] = useState(false);
//   const [departments, setDepartments] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [designations, setDesignations] = useState([]);

//   // Updated form state fields to include monthlyTarget & yearlyTarget
//   const [form, setForm] = useState({
//     name: kra?.name || "",
//     description: kra?.description || "",
//     category: kra?.category || "Technical",
//     departmentId: kra?.departmentId?._id || kra?.departmentId || "",
//     divisionId: kra?.divisionId?._id || kra?.divisionId || "",
//     designationId: kra?.designationId?._id || kra?.designationId || "",
//     reviewCycle: kra?.reviewCycle || "3_MONTHS",
//     status: kra?.status || "ACTIVE",
//     remarks: kra?.remarks || "",
//     monthlyTarget: kra?.monthlyTarget || "", // Added field
//     yearlyTarget: kra?.yearlyTarget || ""   // Added field
//   });

//   // Load Org structural dependencies
//   const loadDependencies = useCallback(async () => {
//     try {
//       const [deptRes, divRes, desRes] = await Promise.all([
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllDivisions.url),
//         api.get(SummaryApi.getAllDesignations?.url || "/api/hr/designations")
//       ]);

//       if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (desRes.data.success) setDesignations(desRes.data.data.map(d => ({ label: d.title, value: d._id })));
//     } catch {
//       toast.error("Failed to load structural parameters.");
//     }
//   }, []);

//   useEffect(() => { loadDependencies(); }, [loadDependencies]);

//   // ரீஃப்ரெஷ் (Refresh) செய்யும்போது View-One API மூலம் தரவுகளைப் பெற்று சின்க் செய்தல்
//   useEffect(() => {
//     const fetchSingleTemplateOnReload = async () => {
//       if (!kra && kraId) {
//         try {
//           const endpoint = SummaryApi.getKraTemplateById?.url
//             ? SummaryApi.getKraTemplateById.url(kraId)
//             : `/api/hr/kra/templates/view-one/${kraId}`;
          
//           const res = await api.get(endpoint);
//           if (res.data.success) {
//             const k = res.data.data;
//             setForm({
//               name: k.name || "",
//               description: k.description || "",
//               category: k.category || "Technical",
//               departmentId: k.departmentId?._id || k.departmentId || "",
//               divisionId: k.divisionId?._id || k.divisionId || "",
//               designationId: k.designationId?._id || k.designationId || "",
//               reviewCycle: k.reviewCycle || "3_MONTHS",
//               status: k.status || "ACTIVE",
//               remarks: k.remarks || "",
//               monthlyTarget: k.monthlyTarget || "", // Sync Target
//               yearlyTarget: k.yearlyTarget || ""   // Sync Target
//             });
//           }
//         } catch {
//           toast.error("Failed to recover KRA details on reload.");
//         }
//       }
//     };
//     fetchSingleTemplateOnReload();
//   }, [kra, kraId]);

//   // Props சின்க் அமைப்பு
//   useEffect(() => {
//     if (kra) {
//       setForm({
//         name: kra.name || "",
//         description: kra.description || "",
//         category: kra.category || "Technical",
//         departmentId: kra.departmentId?._id || kra.departmentId || "",
//         divisionId: kra.divisionId?._id || kra.divisionId || "",
//         designationId: kra.designationId?._id || kra.designationId || "",
//         reviewCycle: kra.reviewCycle || "3_MONTHS",
//         status: kra.status || "ACTIVE",
//         remarks: kra.remarks || "",
//         monthlyTarget: kra.monthlyTarget || "", // Sync Target
//         yearlyTarget: kra.yearlyTarget || ""   // Sync Target
//       });
//     }
//   }, [kra]);

//   const handleSubmit = async () => {
//     if (!form.name.trim()) return toast.error("KRA Name is required.");
//     if (!form.description.trim()) return toast.error("Description is required.");
//     if (!form.departmentId) return toast.error("Please assign a department.");

//     setSaving(true);

//     try {
//       const endpoint = kra?._id || kraId
//         ? `${SummaryApi.updateKraTemplate?.url(kra?._id || kraId)}`
//         : SummaryApi.createKraTemplate?.url;

//       const method = kra?._id || kraId ? "put" : "post";
//       await api[method](endpoint, form);

//       toast.success(`KRA successfully ${kra?._id || kraId ? "updated" : "created"}`);
//       onSave();
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to process KRA template.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="space-y-4 p-2">
//       {/* Interactive Breadcrumbs */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
//         <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
//           <button 
//             type="button"
//             onClick={onClose} 
//             className="hover:text-secondary transition-colors focus:outline-none"
//           >
//             KRA Library
//           </button>
//           <span className="text-gray-300">&gt;</span>
          
//           <button 
//             type="button"
//             onClick={onBackToWizard || onClose} 
//             className="hover:text-secondary transition-colors focus:outline-none"
//           >
//             Individual KRA
//           </button>
//           <span className="text-gray-300">&gt;</span>
          
//           <span className="text-secondary font-bold">
//             {kra?._id || kraId ? "Edit KRA" : "Create New KRA"}
//           </span>
//         </nav>

//         <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
//           Individual KRA
//         </div>
//       </div>
      
//       {/* Main card panel */}
//       <div className="bg-white rounded-xl p-6 space-y-6">
//         <div className="border-b border-gray-50 pb-3">
//           <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wider">Basic Information</h3>
//         </div>

//         <div className="space-y-5">
//           {/* Name */}
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">KRA Name <span className="text-primary text-base">*</span></label>
//             <input 
//               type="text" 
//               value={form.name}
//               onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
//               placeholder="Enter Key Result Area Name (e.g. Revenue Growth, Quality Control)"
//               className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200"
//             />
//           </div>

//           {/* Description */}
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Description *</label>
//             <textarea 
//               value={form.description}
//               onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))}
//               placeholder="Briefly describe the primary objective and expected outcomes of this KRA..."
//               rows={4}
//               className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
//             />
//           </div>

//           {/* Org structure selection row with searchable=true */}
//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//             <div>
//               <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Division</label>
//               <SelectDropdown options={divisions} value={form.divisionId} onChange={(v) => setForm(p => ({ ...p, divisionId: v }))} placeholder="Select division" valueKey="value" labelKey="label" searchable={true} />
//             </div>
//             <div>
//               <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Department</label>
//               <SelectDropdown options={departments} value={form.departmentId} onChange={(v) => setForm(p => ({ ...p, departmentId: v }))} placeholder="Select department" valueKey="value" labelKey="label" searchable={true} />
//             </div>
//             <div>
//               <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Designation</label>
//               <SelectDropdown options={designations} value={form.designationId} onChange={(v) => setForm(p => ({ ...p, designationId: v }))} placeholder="Select designation" valueKey="value" labelKey="label" searchable={true} />
//             </div>
//           </div>

//           {/* Targets Inputs Added inside Template form */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Monthly Target (Optional)</label>
//               <input 
//                 type="text" 
//                 value={form.monthlyTarget}
//                 onChange={(e) => setForm(p => ({ ...p, monthlyTarget: e.target.value }))}
//                 placeholder="e.g. Achieve 90% accuracy"
//                 className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
//               />
//             </div>
//             <div>
//               <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Yearly Target (Optional)</label>
//               <input 
//                 type="text" 
//                 value={form.yearlyTarget}
//                 onChange={(e) => setForm(p => ({ ...p, yearlyTarget: e.target.value }))}
//                 placeholder="e.g. Generate 50+ prospective clients"
//                 className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
//               />
//             </div>
//           </div>

//           {/* Category & Status */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-1">
//             <div>
//               <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Category</label>
//               <input 
//                 type="text" 
//                 value={form.category}
//                 onChange={(e) => setForm(p => ({ ...p, category: e.target.value }))}
//                 placeholder="e.g. Technical, Behavioral"
//                 className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
//               />
//             </div>

//             {/* Toggle Status switch */}
//             <div className="flex flex-col justify-center">
//               <span className="block text-xs font-bold text-gray-700 uppercase mb-1">Status</span>
//               <div className="flex items-center gap-3 bg-gray-50/50 p-2 border rounded-lg max-w-[160px]">
//                 <button 
//                   type="button"
//                   onClick={() => setForm(p => ({ ...p, status: p.status === "ACTIVE" ? "DRAFT" : "ACTIVE" }))}
//                   className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form.status === "ACTIVE" ? "bg-primary" : "bg-gray-300"}`}
//                 >
//                   <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white transition-transform ${form.status === "ACTIVE" ? "translate-x-5" : "translate-x-0"}`} />
//                 </button>
//                 <span className="text-xs font-bold text-gray-600 uppercase">
//                   {form.status === "ACTIVE" ? "Active" : "Draft"}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Review Frequency Buttons */}
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Review Frequency</label>
//             <div className="flex flex-wrap gap-2">
//               {FREQUENCIES.map((freq) => {
//                 const isActive = form.reviewCycle === freq.value;
//                 return (
//                   <button
//                     key={freq.value}
//                     type="button"
//                     onClick={() => setForm(p => ({ ...p, reviewCycle: freq.value }))}
//                     className={`px-5 py-2.5 rounded-full text-xs font-bold border transition-all ${
//                       isActive 
//                         ? "bg-primary text-white border-primary shadow-md shadow-red-200"
//                         : "bg-white text-gray-500 border-gray-200 hover:border-red-300"
//                     }`}
//                   >
//                     {freq.label}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Remarks */}
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Remarks</label>
//             <textarea 
//               value={form.remarks}
//               onChange={(e) => setForm(p => ({ ...p, remarks: e.target.value }))}
//               placeholder="Add any additional context or internal notes regarding this KRA..."
//               rows={3}
//               className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Footer Form Actions */}
//       <div className="flex flex-col sm:flex-row justify-between items-center gap-4 bg-gray-50 py-2">
//         <button onClick={onClose} className="px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase flex items-center gap-1">
//           Cancel
//         </button>
//         <div className="flex gap-3 w-full sm:w-auto">
//           <button 
//             onClick={handleSubmit} 
//             disabled={saving} 
//             className="flex-1 sm:flex-none px-8 py-2.5 bg-primary text-white hover:bg-secondary font-bold rounded-lg text-xs uppercase hover:shadow-lg transition-all"
//           >
//             {saving ? "Saving..." : (kra?._id || kraId ? "Update KRA →" : "Create KRA →")}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import SelectDropdown from "../../customStyles/SelectDropdown";
import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";

const FREQUENCIES = [
  { label: "Weekly", value: "1_WEEK" },
  { label: "Bi-weekly", value: "2_WEEKS" },
  { label: "Monthly", value: "1_MONTH" },
  { label: "Quarterly", value: "3_MONTHS" },
  { label: "Half-Yearly", value: "6_MONTHS" },
  { label: "Annual", value: "12_MONTHS" }
];

// ✅ Added metricType options constant
const METRIC_TYPES = [
  { label: "Higher is Better (Direct Goal)", value: "HIGHER_IS_BETTER" },
  { label: "Lower is Better (Inverse Goal)", value: "LOWER_IS_BETTER" }
];

export default function IndividualKraForm({ kra, kraId, onClose, onSave, onBackToWizard }) {
  const [saving, setSaving] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [designations, setDesignations] = useState([]);

  // Updated form state to include 'metricType' along with targets
  const [form, setForm] = useState({
    name: kra?.name || "",
    description: kra?.description || "",
    category: kra?.category || "Technical",
    departmentId: kra?.departmentId?._id || kra?.departmentId || "",
    divisionId: kra?.divisionId?._id || kra?.divisionId || "",
    designationId: kra?.designationId?._id || kra?.designationId || "",
    reviewCycle: kra?.reviewCycle || "3_MONTHS",
    status: kra?.status || "ACTIVE",
    remarks: kra?.remarks || "",
    targetValue: kra?.targetValue || "", 
    metricType: kra?.metricType || "HIGHER_IS_BETTER", // ✅ Added metricType mapping
    monthlyTarget: kra?.monthlyTarget || "", 
    yearlyTarget: kra?.yearlyTarget || ""   
  });

  // Load Org structural dependencies
  const loadDependencies = useCallback(async () => {
    try {
      const [deptRes, divRes, desRes] = await Promise.all([
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllDivisions.url),
        api.get(SummaryApi.getAllDesignations?.url || "/api/hr/designations")
      ]);

      if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (desRes.data.success) setDesignations(desRes.data.data.map(d => ({ label: d.title, value: d._id })));
    } catch {
      toast.error("Failed to load structural parameters.");
    }
  }, []);

  useEffect(() => { loadDependencies(); }, [loadDependencies]);

  // View-One API sync on page refresh
  useEffect(() => {
    const fetchSingleTemplateOnReload = async () => {
      if (!kra && kraId) {
        try {
          const endpoint = SummaryApi.getKraTemplateById?.url
            ? SummaryApi.getKraTemplateById.url(kraId)
            : `/api/hr/kra/templates/view-one/${kraId}`;
          
          const res = await api.get(endpoint);
          if (res.data.success) {
            const k = res.data.data;
            setForm({
              name: k.name || "",
              description: k.description || "",
              category: k.category || "Technical",
              departmentId: k.departmentId?._id || k.departmentId || "",
              divisionId: k.divisionId?._id || k.divisionId || "",
              designationId: k.designationId?._id || k.designationId || "",
              reviewCycle: k.reviewCycle || "3_MONTHS",
              status: k.status || "ACTIVE",
              remarks: k.remarks || "",
              targetValue: k.targetValue || "", 
              metricType: k.metricType || "HIGHER_IS_BETTER", // ✅ Sync metricType
              monthlyTarget: k.monthlyTarget || "", 
              yearlyTarget: k.yearlyTarget || ""   
            });
          }
        } catch {
          toast.error("Failed to recover KRA details on reload.");
        }
      }
    };
    fetchSingleTemplateOnReload();
  }, [kra, kraId]);

  // Sync state when props change
  useEffect(() => {
    if (kra) {
      setForm({
        name: kra.name || "",
        description: kra.description || "",
        category: kra.category || "Technical",
        departmentId: kra.departmentId?._id || kra.departmentId || "",
        divisionId: kra.divisionId?._id || kra.divisionId || "",
        designationId: kra.designationId?._id || kra.designationId || "",
        reviewCycle: kra.reviewCycle || "3_MONTHS",
        status: kra.status || "ACTIVE",
        remarks: kra.remarks || "",
        targetValue: kra.targetValue || "", 
        metricType: kra.metricType || "HIGHER_IS_BETTER", // ✅ Sync metricType
        monthlyTarget: kra.monthlyTarget || "", 
        yearlyTarget: kra.yearlyTarget || ""   
      });
    }
  }, [kra]);

  const handleSubmit = async () => {
    if (!form.name.trim()) return toast.error("KRA Name is required.");
    if (!form.description.trim()) return toast.error("Description is required.");
    if (!form.departmentId) return toast.error("Please assign a department.");

    setSaving(true);

    try {
      const endpoint = kra?._id || kraId
        ? `${SummaryApi.updateKraTemplate?.url(kra?._id || kraId)}`
        : SummaryApi.createKraTemplate?.url;

      const method = kra?._id || kraId ? "put" : "post";
      await api[method](endpoint, form);

      toast.success(`KRA successfully ${kra?._id || kraId ? "updated" : "created"}`);
      onSave();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to process KRA template.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4 p-2">
      {/* Interactive Breadcrumbs */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
          <button 
            type="button"
            onClick={onClose} 
            className="hover:text-secondary transition-colors focus:outline-none"
          >
            KRA Library
          </button>
          <span className="text-gray-300">&gt;</span>
          
          <button 
            type="button"
            onClick={onBackToWizard || onClose} 
            className="hover:text-secondary transition-colors focus:outline-none"
          >
            Individual KRA
          </button>
          <span className="text-gray-300">&gt;</span>
          
          <span className="text-secondary font-bold">
            {kra?._id || kraId ? "Edit KRA" : "Create New KRA"}
          </span>
        </nav>

        <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
          Individual KRA
        </div>
      </div>
      
      {/* Main card panel */}
      <div className="bg-white rounded-xl p-6 space-y-6">
        <div className="border-b border-gray-50 pb-3">
          <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wider">Basic Information</h3>
        </div>

        <div className="space-y-5">
          {/* Name */}
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">KRA Name <span className="text-primary text-base">*</span></label>
            <input 
              type="text" 
              value={form.name}
              onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
              placeholder="Enter Key Result Area Name (e.g. Revenue Growth, Quality Control)"
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200"
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Description *</label>
            <textarea 
              value={form.description}
              onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))}
              placeholder="Briefly describe the primary objective and expected outcomes of this KRA..."
              rows={4}
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
            />
          </div>

          {/* Org structure selection row */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Division</label>
              <SelectDropdown options={divisions} value={form.divisionId} onChange={(v) => setForm(p => ({ ...p, divisionId: v }))} placeholder="Select division" valueKey="value" labelKey="label" searchable={true} />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Department</label>
              <SelectDropdown options={departments} value={form.departmentId} onChange={(v) => setForm(p => ({ ...p, departmentId: v }))} placeholder="Select department" valueKey="value" labelKey="label" searchable={true} />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Designation</label>
              <SelectDropdown options={designations} value={form.designationId} onChange={(v) => setForm(p => ({ ...p, designationId: v }))} placeholder="Select designation" valueKey="value" labelKey="label" searchable={true} />
            </div>
          </div>

          {/* Unified Target, Goal Direction & Legacy Fallback Targets Layout */}
          {/* ✅ Expanded grid to md:grid-cols-4 to neatly place Goal/Metric Direction */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-gray-50/50 p-4 rounded-xl border border-gray-100">
            <div>
              <label className="block text-xs font-bold text-primary uppercase mb-1">
                Target Value <span className="text-red-500">*</span>
              </label>
              <input 
                type="text" 
                value={form.targetValue}
                onChange={(e) => setForm(p => ({ ...p, targetValue: e.target.value }))}
                placeholder="Primary target (e.g. 25 APIs)"
                className="w-full border border-red-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200 font-semibold"
              />
              <p className="text-[10px] text-gray-400 mt-1">Recommended. Matches the review cycle frequency.</p>
            </div>
            {/* ✅ Added Goal/Metric Direction Dropdown */}
            <div>
              <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Goal Direction</label>
              <SelectDropdown 
                options={METRIC_TYPES} 
                value={form.metricType} 
                onChange={(v) => setForm(p => ({ ...p, metricType: v }))} 
                placeholder="Select Direction" 
                valueKey="value" 
                labelKey="label" 
                searchable={false} 
              />
              <p className="text-[10px] text-gray-400 mt-1">Defines direct vs inverse score calculations.</p>
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-600 uppercase mb-1">Monthly Target (Legacy Fallback)</label>
              <input 
                type="text" 
                value={form.monthlyTarget}
                onChange={(e) => setForm(p => ({ ...p, monthlyTarget: e.target.value }))}
                placeholder="e.g. Achieve 90% accuracy"
                className="w-full border border-gray-200 bg-white rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-600 uppercase mb-1">Yearly Target (Legacy Fallback)</label>
              <input 
                type="text" 
                value={form.yearlyTarget}
                onChange={(e) => setForm(p => ({ ...p, yearlyTarget: e.target.value }))}
                placeholder="e.g. Generate 50+ clients"
                className="w-full border border-gray-200 bg-white rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
              />
            </div>
          </div>

          {/* Category & Status */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-1">
            <div>
              <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Category</label>
              <input 
                type="text" 
                value={form.category}
                onChange={(e) => setForm(p => ({ ...p, category: e.target.value }))}
                placeholder="e.g. Technical, Behavioral"
                className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
              />
            </div>

            {/* Toggle Status switch */}
            <div className="flex flex-col justify-center">
              <span className="block text-xs font-bold text-gray-700 uppercase mb-1">Status</span>
              <div className="flex items-center gap-3 bg-gray-50/50 p-2 border rounded-lg max-w-[160px]">
                <button 
                  type="button"
                  onClick={() => setForm(p => ({ ...p, status: p.status === "ACTIVE" ? "DRAFT" : "ACTIVE" }))}
                  className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form.status === "ACTIVE" ? "bg-primary" : "bg-gray-300"}`}
                >
                  <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white transition-transform ${form.status === "ACTIVE" ? "translate-x-5" : "translate-x-0"}`} />
                </button>
                <span className="text-xs font-bold text-gray-600 uppercase">
                  {form.status === "ACTIVE" ? "Active" : "Draft"}
                </span>
              </div>
            </div>
          </div>

          {/* Review Frequency Buttons */}
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Review Frequency</label>
            <div className="flex flex-wrap gap-2">
              {FREQUENCIES.map((freq) => {
                const isActive = form.reviewCycle === freq.value;
                return (
                  <button
                    key={freq.value}
                    type="button"
                    onClick={() => setForm(p => ({ ...p, reviewCycle: freq.value }))}
                    className={`px-5 py-2.5 rounded-full text-xs font-bold border transition-all ${
                      isActive 
                        ? "bg-primary text-white border-primary shadow-md shadow-red-200"
                        : "bg-white text-gray-500 border-gray-200 hover:border-red-300"
                    }`}
                  >
                    {freq.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Remarks */}
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Remarks</label>
            <textarea 
              value={form.remarks}
              onChange={(e) => setForm(p => ({ ...p, remarks: e.target.value }))}
              placeholder="Add any additional context or internal notes regarding this KRA..."
              rows={3}
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
            />
          </div>
        </div>
      </div>

      {/* Footer Form Actions */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 bg-gray-50 py-2">
        <button onClick={onClose} className="px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase flex items-center gap-1">
          Cancel
        </button>
        <div className="flex gap-3 w-full sm:w-auto">
          <button 
            onClick={handleSubmit} 
            disabled={saving} 
            className="flex-1 sm:flex-none px-8 py-2.5 bg-primary text-white hover:bg-secondary font-bold rounded-lg text-xs uppercase hover:shadow-lg transition-all"
          >
            {saving ? "Saving..." : (kra?._id || kraId ? "Update KRA →" : "Create KRA →")}
          </button>
        </div>
      </div>
    </div>
  );
}